<template>
  <div class="apartment-main-info">
    <ul class="apartment-main-info-list">
      <li class="apartment-main-info-list-item main-info-title hidden-xs-only">
        <router-link :to="{ name: 'flat-detail', params: { id: item.id } }"
          >{{ item.rooms }} к - {{ item.district.name }}
        </router-link>
      </li>
      <li
        class="apartment-main-info-list-item main-info-title hidden-xs-only"
        v-if="showPrise"
      >
        <ApartmentPrise :price="item.price" :id="item.id" />
      </li>
      <li class="apartment-main-info-list-item">
        <div class="apartment-list-item-icon">
          <IconBase height="16" width="16">
            <Gps />
          </IconBase>
        </div>
        <div class="apartment-list-item-text">
          <span class="apartment-info-type">Орієнтир : </span
          ><span class="apartment-type-value" v-if="item.guide">{{
            item.guide
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li class="apartment-main-info-list-item">
        <div class="apartment-list-item-icon">
          <IconBase height="16" width="16">
            <House />
          </IconBase>
        </div>
        <div class="apartment-list-item-text">
          <span class="apartment-info-type">Тип : </span
          ><span class="apartment-type-value"
            >{{ item.planning ? item.planning.name : '-' }}
          </span>
        </div>
      </li>
      <li class="apartment-main-info-list-item">
        <div class="apartment-list-item-icon">
          <IconBase height="16" width="16">
            <Square />
          </IconBase>
        </div>
        <div class="apartment-list-item-text">
          <span class="apartment-info-type">Площа : </span
          ><span class="apartment-type-value" v-if="item.area"
            >{{ item.area }} м2</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li class="apartment-main-info-list-item">
        <div class="apartment-list-item-icon">
          <IconBase height="16" width="16">
            <ApartmentHouse />
          </IconBase>
        </div>
        <div class="apartment-list-item-text">
          <span class="apartment-info-type">Поверх : </span
          ><span class="apartment-type-value"
            >{{ item.floor }}/{{ item.floors }}</span
          >
        </div>
      </li>
      <li class="apartment-main-info-list-item">
        <div class="apartment-list-item-icon">
          <IconBase height="16" width="16">
            <ApartmentState />
          </IconBase>
        </div>
        <div class="apartment-list-item-text">
          <span class="apartment-info-type">Стан : </span
          ><span class="apartment-type-value" v-if="item.state">{{
            item.state.name
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li class="apartment-main-info-list-item">
        <div class="apartment-list-item-icon">
          <IconBase height="16" width="16">
            <Boxes />
          </IconBase>
        </div>
        <div class="apartment-list-item-text">
          <span class="apartment-info-type">Матеріал : </span
          ><span class="apartment-type-value" v-if="item.material">
            {{ item.material }}</span
          >
          <span v-else>-</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import IconBase from '@/components/icons/IconBase'
import Gps from '@/components/icons/Gps'
import Boxes from '@/components/icons/Boxes'
import ApartmentState from '@/components/icons/ApartmentState'
import ApartmentHouse from '@/components/icons/ApartmentHouse'
import Square from '@/components/icons/Square'
import House from '@/components/icons/House'
import ApartmentPrise from '@/components/common/apartment_partials/ApartmentPrise'

export default {
  name: 'ApartmentInfo',
  props: {
    showPrise: Boolean,
    item: Object,
  },
  components: {
    ApartmentPrise,
    Gps,
    Boxes,
    IconBase,
    ApartmentState,
    ApartmentHouse,
    Square,
    House,
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.apartment-main-info {
  padding-top: 2rem;
  padding-left: 1rem;

  .apartment-main-info-list {
    list-style: none;
    font-family: 'Nunito-Regular', sans-serif;
    font-size: 1.4rem;

    .apartment-main-info-list-item {
      display: flex;
      align-items: center;

      &:first-child {
        margin-bottom: 2.7rem;
      }

      &:not(:last-child) {
        margin-bottom: 2.2rem;
      }

      &.main-info-title {
        white-space: nowrap;
        a {
          text-decoration: none;
          outline: none;
          font-size: 2.8rem;
          font-weight: normal;
          color: #110729;
          white-space: nowrap;
          &:visited {
            color: #110729;
          }
        }
      }

      .apartment-list-item-icon {
        margin-right: 0.7rem;
      }

      .apartment-list-item-text {
        .apartment-info-type {
          font-size: 14px;
        }

        .apartment-type-value {
          font-weight: bolder;
        }
      }
    }
  }
}
</style>
